import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=8dc30500&"
import script from "./RatingInput.vue?vue&type=script&lang=js&"
export * from "./RatingInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports